import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/House.svg?component
var House_exports = /* @__PURE__ */ __exportAll({
	default: () => House_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M22.1 9.2 12 1.5 1.8 9.2c-.2.2-.3.5-.4.7v11.7c0 .5.4.9.9.9h6.1v-4.9c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5v4.9h6.1c.5 0 .9-.4.9-.9V9.9c0-.3-.1-.6-.4-.7z" }, null, -1)])]);
}
var House_default = { render: render$1 };
//#endregion
export { House_exports, House_default as default, render$1 as render };

//# sourceMappingURL=House.svg_component.js.map